import { IComponentGroup } from './shared';

const componentGroups: IComponentGroup[] = [
  {
    label: '布局控件',
    components: [
      {
        label: '分组',
        type: 'string',
        widget: 'group',
        icon: 'icon-fenzu'
      },
      {
        label: '标题',
        type: 'string',
        widget: 'title',
        icon: 'icon-biaoti'
      },
      {
        label: '图片',
        type: 'img',
        widget: 'image',
        icon: 'icon-tupian'
      }
    ]
  },
  {
    label: '基础控件',
    components: [
      {
        label: '单行文本',
        type: 'string',
        widget: 'string',
        icon: 'icon-danhangwenben'
      },
      {
        label: '多行文本',
        type: 'string',
        widget: 'textarea',
        icon: 'icon-duohangwenben'
      },
      {
        label: '数字输入',
        type: 'number',
        widget: 'number',
        icon: "icon-shuzishuru"
      },

      {
        label: '单项框组',
        type: 'string',
        widget: 'radio',
        icon: "icon-danxiangxuankuang-copy"
      },
      {
        label: '多选框组',
        type: 'string',
        widget: 'checkbox',
        icon: "icon-duoxiangxuankuang"
      },
      {
        label: '下拉选择',
        type: 'number',
        widget: 'select',
        icon: "icon-xialaxuanze"
      },
      {
        label: '日期选择器',
        type: 'string',
        widget: 'date',
        icon: "icon-riqixuanze"
      },
      {
        label: '日期范围选择器',
        type: 'string',
        widget: 'date-range',
        icon: "icon-riqifanweixuanze"
      },
      {
        label: '文件上传',
        type: 'string',
        widget: 'uploadfile',
        icon: "icon-wenjianshangchuan"
      },
      {
        label: '颜色选择',
        type: 'string',
        widget: 'colorpicker',
        icon: "icon-yansexuanze"
      },
      {
        label: '评分',
        type: 'string',
        widget: 'rate',
        icon: "icon-pingfen"
      },
      {
        label: '滑块',
        type: 'string',
        widget: 'slider',
        icon: "icon-huakuai"
      },
      {
        label: '分割线',
        type: 'string',
        widget: 'splitline',
        icon: "icon-fengexian"
      },
      {
        label: '文本',
        type: 'string',
        widget: 'text',
        icon: "icon-wenben"
      },
      {
        label: '富文本',
        type: 'string',
        widget: 'ueditor',
        icon: "icon-fuwenben"
      }
    ]
  },
  {
    label: '动态表单项',
    components: [
      {
        label: '文本输入',
        type: 'string',
        widget: 'con-string',
        icon: "icon-wenben"
      },
      {
        label: '整数数字输入',
        type: 'number-integer',
        widget: 'con-number-integer',
        icon: "icon-zhengshushuzishuru"
      },
      {
        label: '浮点数字输入',
        type: 'number-float',
        widget: 'con-number-float',
        icon: "icon-fudianshuzi"
      },
      {
        label: '十进制数字输入',
        type: 'number-decimal',
        widget: 'con-number-decimal',
        icon: "icon-shijinzhi"
      },
      {
        label: '单项框组',
        type: 'boolean',
        widget: 'con-boolean',
        icon: "icon-danxiangxuankuang-copy"
      },
      {
        label: '固定值',
        type: 'string',
        widget: 'con-fixed',
        icon: "icon-gudingzhi"
      },
      {
        label: '时间选择器',
        type: 'string',
        widget: 'con-timestamp',
        icon: "icon-riqixuanze"
      }
    ]
  }
];

export { componentGroups };
